import { useCallback, useMemo } from "react"
import useRequest from "./useRequest";
import { API_CONNECTED_OBJECT, API_USER, BASE_ADMIN } from "../constants/api";

const useRemoveFromUser = (userID: number) => {
  const {request: removeFrom, response, error, isLoading} = useRequest<{message: string}>();
  const removed = useMemo(() => !isLoading && !!response, [isLoading, response])

  const removeObj = useCallback((id: number) => {
    removeFrom(BASE_ADMIN, `${API_USER}/${userID}/${API_CONNECTED_OBJECT}/${id}`, {secure: true, method: 'DELETE'})
  }, [removeFrom, userID])

  return {
    removeObj, removed, errorWhenRemove: error
  }
}

export default useRemoveFromUser;